// PARTNER-PORTÁL · Adatkezelési tájékoztató (statikus, i18n-ből).
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { PortalLegalPage } from '@/components/portal/portal-legal-page';
import { usePortalHead } from '@/features/portal/portal-context';

export const Route = createFileRoute('/portal/legal/gdpr')({
  component: PortalGdprPage,
});

function PortalGdprPage(): JSX.Element {
  const { t } = useTranslation();
  usePortalHead({ title: t('portal.nav.gdpr'), subtitle: t('portal.legal.gdpr.updated') }, [
    t('portal.nav.gdpr'),
  ]);
  return <PortalLegalPage blocksKey="portal.legal.gdpr.blocks" />;
}
